// AWS API Gateway URL
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://r1zql1dill.execute-api.eu-central-1.amazonaws.com/prod';

export const API_TIMEOUT = 30000; // 30 saniye

export const API_ENDPOINTS = {
  YUZ_TANI: '/yuz-tani',
  VELI_KAYIT: '/veli-kayit',
};
